import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DutyTypeEditorV2.html?raw';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';

class DutyTypeEditorV2 extends compose(MainCatalogsEditorBaseV2) {
    templateString: any = template;

    dt_Input_Classname: MdsLax<InstanceType<typeof SearchSelect>>;
    dt_Input_PercentagePresent: MdsLax<InstanceType<typeof NumberInput>>;
    percentagePresentContainer: HTMLDivElement;
    dt_Input_PercentageFree: MdsLax<InstanceType<typeof NumberInput>>;
    percentageFreeContainer: HTMLDivElement;
    dt_Input_PercentageCount: MdsLax<InstanceType<typeof NumberInput>>;


    isValid(): boolean {
        //Need to implement
        return true;
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.OMDutyType;
    }

    protected afterSetData() {
        super.afterSetData.apply(this, arguments as any);

        this.dt_Input_Classname.setReadonly(true);

        var className = this.getAttributeValue("Classname");

        switch (className) {
            case "absenteeism_type":
                this.hideNode(this.dt_Input_PercentagePresent);
                this.hideNode(this.percentagePresentContainer);
                this.dt_Input_PercentagePresent.destroy();
                this.dt_Input_PercentageFree.setReadonly(false);
                this.entityClass = MainCatalogs_Classes.AbsenteeismType;
                break;
            case "present_type":
                this.hideNode(this.dt_Input_PercentageFree);
                this.hideNode(this.percentageFreeContainer);
                this.dt_Input_PercentageFree.destroy();
                this.dt_Input_PercentagePresent.setReadonly(false);
                this.entityClass = MainCatalogs_Classes.PresentType;

                break;
        }
    }

    protected _onChanged(attribute: string, value: any) {
        switch (attribute) {
            case "Classname":
                switch (value?.classname) {
                    case "absenteeism_type":
                        this.dt_Input_PercentageFree.setReadonly(false);
                        this.dt_Input_PercentagePresent.setReadonly(true);
                        this.entityClass = MainCatalogs_Classes.AbsenteeismType;
                        break;
                    case "present_type":
                        this.dt_Input_PercentagePresent.setReadonly(false);
                        this.dt_Input_PercentageFree.setReadonly(true);
                        this.entityClass = MainCatalogs_Classes.PresentType;
                        break;
                    default:
                        this.dt_Input_PercentagePresent.setReadonly(true);
                        this.dt_Input_PercentageFree.setReadonly(true);
                        this.entityClass = MainCatalogs_Classes.OMDutyType;
                        break;
                }
                break;
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.dt_Input_PercentageFree.setReadonly(true);
        this.dt_Input_PercentagePresent.setReadonly(true);


        this.dt_Input_PercentageFree.setMinRange(0);
        this.dt_Input_PercentageCount.setMinRange(0);
        this.dt_Input_PercentagePresent.setMinRange(0);


        this.dt_Input_PercentageFree.setMaxRange(100);
        this.dt_Input_PercentageCount.setMaxRange(100);
        this.dt_Input_PercentagePresent.setMaxRange(100);


        this.dt_Input_PercentageFree.setStep("0.01");
        this.dt_Input_PercentageCount.setStep("0.01");
        this.dt_Input_PercentagePresent.setStep("0.01");
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(DutyTypeEditorV2);
